<template>
    <el-dialog
            :visible.sync="isShow"
            width="80%"
            @close="handelClose"
            >
            <div class="container">
                <div class="dialog_top">
                    <img src="~@/components/kw/img/Ali_03.png" alt="">
                    <div class="tip_title">恭喜您预约成功</div>
                </div>
                <img class="QRcode" src="~@/components/kw/img/QR_gzh.png" alt="">
                <p>为了方便您更好地参与展会</p>
                <p>请扫码关注公众号</p>
            </div>
    </el-dialog>
</template>

<script>
    export default {
        name: "kw_dialog",
        props: {
            isSuccess: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            isSuccess(newVal) {
                this.isShow = newVal;
            }
        },
        data() {
            return {
                isShow: this.isSuccess
            }
        },
        methods: {
            handelClose() {
                this.$emit("handelClose")
            }
        }
    }
</script>

<style scoped>
    .container {
        /*width: 80%;*/
        /*background: #fff;*/
        /*border-radius: 30px;*/
        /*position: absolute;*/
        /*top: 50%;*/
        /*left: 50%;*/
        /*transform: translate(-50%, -50%);*/
        padding: 30px 0 46px;
        text-align: center;
    }
    .dialog_top {
        position: relative;
    }
    .dialog_top img {
        position: absolute;
        left: 45px;
        top: -20px;
        width: 60px;
    }
    .dialog_top .tip_title {
        width: 60%;
        background: #EEEEEE;
        padding: 7px 0 7px 40px;
        text-align: center;
        color:#FF3A34;
        font-size: 16px;
        margin: 0 auto;
        border-radius:10px;
    }
    .QRcode {
        width: 150px;
        margin: 10px 0;
    }

    p {
        margin-bottom: 7px;
    }
</style>
